import { SiteService } from "./Site.service";

export default {
  siteService: {
    class: SiteService,
    public: true,
    arguments: [{ $ref: "apiService" }]
  }
};
